import { render, staticRenderFns } from "./helpOther.vue?vue&type=template&id=29069239&scoped=true&"
import script from "./helpOther.vue?vue&type=script&lang=js&"
export * from "./helpOther.vue?vue&type=script&lang=js&"
import style0 from "./helpOther.vue?vue&type=style&index=0&id=29069239&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29069239",
  null
  
)

export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/components/helpOther.vue
// module id = null
// module chunks = 